// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/user/user_service.proto (package api.v1.user, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { LatLng } from "../../google/type/latlng_pb";
import { file_google_type_latlng } from "../../google/type/latlng_pb";
import { file_v1_common_common_types } from "../common/common_types_pb";
import { file_v1_image_image_service } from "../image/image_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/user/user_service.proto.
 */
export const file_v1_user_user_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_protobuf_timestamp, file_google_protobuf_empty, file_google_type_latlng, file_v1_common_common_types, file_v1_image_image_service]);

/**
 * Image represents an image entity
 *
 * @generated from message api.v1.user.Image
 */
export type Image = Message<"api.v1.user.Image"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string usage = 3;
   */
  usage: string;

  /**
   * @generated from field: optional string alt_text = 4;
   */
  altText?: string;

  /**
   * @generated from field: optional int32 position = 5;
   */
  position?: number;
};

/**
 * Describes the message api.v1.user.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 0);

/**
 * LocationData represents a complete location with address information
 *
 * @generated from message api.v1.user.LocationData
 */
export type LocationData = Message<"api.v1.user.LocationData"> & {
  /**
   * @generated from field: google.type.LatLng coordinates = 1;
   */
  coordinates?: LatLng;

  /**
   * @generated from field: optional string formatted_address = 2;
   */
  formattedAddress?: string;

  /**
   * @generated from field: optional string place_id = 3;
   */
  placeId?: string;

  /**
   * @generated from field: optional string postal_code = 4;
   */
  postalCode?: string;

  /**
   * @generated from field: optional string city = 5;
   */
  city?: string;

  /**
   * @generated from field: optional string state = 6;
   */
  state?: string;

  /**
   * @generated from field: optional string country = 7;
   */
  country?: string;
};

/**
 * Describes the message api.v1.user.LocationData.
 * Use `create(LocationDataSchema)` to create a new message.
 */
export const LocationDataSchema: GenMessage<LocationData> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 1);

/**
 * SavedLocation represents a user's saved location
 *
 * @generated from message api.v1.user.SavedLocation
 */
export type SavedLocation = Message<"api.v1.user.SavedLocation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * User-defined name like "Home", "Work", "Gym"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: api.v1.user.LocationData location_data = 3;
   */
  locationData?: LocationData;

  /**
   * Primary location for searches
   *
   * @generated from field: bool is_primary = 4;
   */
  isPrimary: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.user.SavedLocation.
 * Use `create(SavedLocationSchema)` to create a new message.
 */
export const SavedLocationSchema: GenMessage<SavedLocation> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 2);

/**
 * Enhanced LocationPreferences with multiple saved locations and privacy settings
 *
 * @generated from message api.v1.user.LocationPreferences
 */
export type LocationPreferences = Message<"api.v1.user.LocationPreferences"> & {
  /**
   * Legacy fields (maintain backward compatibility)
   *
   * @generated from field: api.v1.user.LocationSearchType search_location_type = 1;
   */
  searchLocationType: LocationSearchType;

  /**
   * @generated from field: optional string search_postal_code = 2;
   */
  searchPostalCode?: string;

  /**
   * @generated from field: optional int32 search_radius_km = 3;
   */
  searchRadiusKm?: number;

  /**
   * @generated from field: optional google.type.LatLng search_coordinates = 4;
   */
  searchCoordinates?: LatLng;

  /**
   * Enhanced location preferences
   *
   * @generated from field: repeated api.v1.user.SavedLocation saved_locations = 5;
   */
  savedLocations: SavedLocation[];

  /**
   * @generated from field: bool auto_location_detection = 6;
   */
  autoLocationDetection: boolean;

  /**
   * @generated from field: api.v1.user.LocationUnit preferred_unit = 7;
   */
  preferredUnit: LocationUnit;

  /**
   * @generated from field: api.v1.user.LocationSharingLevel sharing_level = 8;
   */
  sharingLevel: LocationSharingLevel;

  /**
   * @generated from field: bool share_in_search_results = 9;
   */
  shareInSearchResults: boolean;

  /**
   * ID of default saved location
   *
   * @generated from field: optional string default_location_id = 10;
   */
  defaultLocationId?: string;

  /**
   * Include orgs with service areas in searches
   *
   * @generated from field: bool include_service_areas = 11;
   */
  includeServiceAreas: boolean;
};

/**
 * Describes the message api.v1.user.LocationPreferences.
 * Use `create(LocationPreferencesSchema)` to create a new message.
 */
export const LocationPreferencesSchema: GenMessage<LocationPreferences> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 3);

/**
 * @generated from message api.v1.user.FirebaseUser
 */
export type FirebaseUser = Message<"api.v1.user.FirebaseUser"> & {
  /**
   * @generated from field: string uid = 1;
   */
  uid: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: optional string display_name = 3;
   */
  displayName?: string;

  /**
   * @generated from field: optional string photo_url = 4;
   */
  photoUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.user.FirebaseUser.
 * Use `create(FirebaseUserSchema)` to create a new message.
 */
export const FirebaseUserSchema: GenMessage<FirebaseUser> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 4);

/**
 * Profile Types
 *
 * @generated from message api.v1.user.UserProfile
 */
export type UserProfile = Message<"api.v1.user.UserProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: optional string bio = 6;
   */
  bio?: string;

  /**
   * @generated from field: repeated api.v1.user.Image images = 7;
   */
  images: Image[];

  /**
   * @generated from field: optional api.v1.user.LocationPreferences location_preferences = 8;
   */
  locationPreferences?: LocationPreferences;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional api.v1.user.ActiveOrg active_org = 11;
   */
  activeOrg?: ActiveOrg;
};

/**
 * Describes the message api.v1.user.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema: GenMessage<UserProfile> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 5);

/**
 * Preference Types
 *
 * @generated from message api.v1.user.NotificationSettings
 */
export type NotificationSettings = Message<"api.v1.user.NotificationSettings"> & {
  /**
   * @generated from field: bool enable_push = 1;
   */
  enablePush: boolean;

  /**
   * @generated from field: bool enable_email = 2;
   */
  enableEmail: boolean;

  /**
   * @generated from field: bool enable_sms = 3;
   */
  enableSms: boolean;
};

/**
 * Describes the message api.v1.user.NotificationSettings.
 * Use `create(NotificationSettingsSchema)` to create a new message.
 */
export const NotificationSettingsSchema: GenMessage<NotificationSettings> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 6);

/**
 * @generated from message api.v1.user.EmailPreferences
 */
export type EmailPreferences = Message<"api.v1.user.EmailPreferences"> & {
  /**
   * @generated from field: bool marketing_emails = 1;
   */
  marketingEmails: boolean;

  /**
   * @generated from field: bool event_updates = 2;
   */
  eventUpdates: boolean;

  /**
   * @generated from field: bool org_updates = 3;
   */
  orgUpdates: boolean;
};

/**
 * Describes the message api.v1.user.EmailPreferences.
 * Use `create(EmailPreferencesSchema)` to create a new message.
 */
export const EmailPreferencesSchema: GenMessage<EmailPreferences> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 7);

/**
 * @generated from message api.v1.user.PrivacySettings
 */
export type PrivacySettings = Message<"api.v1.user.PrivacySettings"> & {
  /**
   * @generated from field: bool public_profile = 1;
   */
  publicProfile: boolean;

  /**
   * @generated from field: bool show_location = 2;
   */
  showLocation: boolean;

  /**
   * @generated from field: bool show_activity = 3;
   */
  showActivity: boolean;
};

/**
 * Describes the message api.v1.user.PrivacySettings.
 * Use `create(PrivacySettingsSchema)` to create a new message.
 */
export const PrivacySettingsSchema: GenMessage<PrivacySettings> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 8);

/**
 * @generated from message api.v1.user.UserPreferences
 */
export type UserPreferences = Message<"api.v1.user.UserPreferences"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: api.v1.user.NotificationSettings notification_settings = 2;
   */
  notificationSettings?: NotificationSettings;

  /**
   * @generated from field: api.v1.user.EmailPreferences email_preferences = 3;
   */
  emailPreferences?: EmailPreferences;

  /**
   * @generated from field: api.v1.user.PrivacySettings privacy_settings = 4;
   */
  privacySettings?: PrivacySettings;

  /**
   * @generated from field: api.v1.user.LocationPreferences location_preferences = 5;
   */
  locationPreferences?: LocationPreferences;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.user.UserPreferences.
 * Use `create(UserPreferencesSchema)` to create a new message.
 */
export const UserPreferencesSchema: GenMessage<UserPreferences> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 9);

/**
 * @generated from message api.v1.user.CreateImageRequest
 */
export type CreateImageRequest = Message<"api.v1.user.CreateImageRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string usage = 3;
   */
  usage: string;

  /**
   * @generated from field: optional string alt_text = 4;
   */
  altText?: string;

  /**
   * @generated from field: optional int32 position = 5;
   */
  position?: number;
};

/**
 * Describes the message api.v1.user.CreateImageRequest.
 * Use `create(CreateImageRequestSchema)` to create a new message.
 */
export const CreateImageRequestSchema: GenMessage<CreateImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 10);

/**
 * @generated from message api.v1.user.CreateUserRequest
 */
export type CreateUserRequest = Message<"api.v1.user.CreateUserRequest"> & {
  /**
   * @generated from field: optional string first_name = 1;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 2;
   */
  lastName?: string;

  /**
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: api.v1.user.LocationPreferences location_preferences = 5;
   */
  locationPreferences?: LocationPreferences;
};

/**
 * Describes the message api.v1.user.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 11);

/**
 * @generated from message api.v1.user.CreateUserResponse
 */
export type CreateUserResponse = Message<"api.v1.user.CreateUserResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message api.v1.user.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema: GenMessage<CreateUserResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 12);

/**
 * @generated from message api.v1.user.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"api.v1.user.UpdateUserRequest"> & {
  /**
   * @generated from field: optional string first_name = 1;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 2;
   */
  lastName?: string;

  /**
   * @generated from field: optional string bio = 3;
   */
  bio?: string;

  /**
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: repeated api.v1.user.Image images = 5;
   */
  images: Image[];
};

/**
 * Describes the message api.v1.user.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 13);

/**
 * @generated from message api.v1.user.UpdateUserResponse
 */
export type UpdateUserResponse = Message<"api.v1.user.UpdateUserResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api.v1.user.UpdateUserResponse.
 * Use `create(UpdateUserResponseSchema)` to create a new message.
 */
export const UpdateUserResponseSchema: GenMessage<UpdateUserResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 14);

/**
 * @generated from message api.v1.user.DeleteUserRequest
 */
export type DeleteUserRequest = Message<"api.v1.user.DeleteUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message api.v1.user.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema: GenMessage<DeleteUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 15);

/**
 * @generated from message api.v1.user.CheckUsernameRequest
 */
export type CheckUsernameRequest = Message<"api.v1.user.CheckUsernameRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message api.v1.user.CheckUsernameRequest.
 * Use `create(CheckUsernameRequestSchema)` to create a new message.
 */
export const CheckUsernameRequestSchema: GenMessage<CheckUsernameRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 16);

/**
 * @generated from message api.v1.user.CheckUsernameResponse
 */
export type CheckUsernameResponse = Message<"api.v1.user.CheckUsernameResponse"> & {
  /**
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * @generated from field: bool valid = 2;
   */
  valid: boolean;

  /**
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: string checked_username = 4;
   */
  checkedUsername: string;
};

/**
 * Describes the message api.v1.user.CheckUsernameResponse.
 * Use `create(CheckUsernameResponseSchema)` to create a new message.
 */
export const CheckUsernameResponseSchema: GenMessage<CheckUsernameResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 17);

/**
 * @generated from message api.v1.user.EnsureUserProfileRequest
 */
export type EnsureUserProfileRequest = Message<"api.v1.user.EnsureUserProfileRequest"> & {
  /**
   * @generated from oneof api.v1.user.EnsureUserProfileRequest.auth_method
   */
  authMethod: {
    /**
     * Token-based authentication
     *
     * @generated from field: string id_token = 1;
     */
    value: string;
    case: "idToken";
  } | {
    /**
     * API key authentication (for Firebase functions)
     *
     * @generated from field: api.v1.user.ApiKeyAuth api_key_auth = 2;
     */
    value: ApiKeyAuth;
    case: "apiKeyAuth";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message api.v1.user.EnsureUserProfileRequest.
 * Use `create(EnsureUserProfileRequestSchema)` to create a new message.
 */
export const EnsureUserProfileRequestSchema: GenMessage<EnsureUserProfileRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 18);

/**
 * @generated from message api.v1.user.ApiKeyAuth
 */
export type ApiKeyAuth = Message<"api.v1.user.ApiKeyAuth"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: optional string display_name = 3;
   */
  displayName?: string;
};

/**
 * Describes the message api.v1.user.ApiKeyAuth.
 * Use `create(ApiKeyAuthSchema)` to create a new message.
 */
export const ApiKeyAuthSchema: GenMessage<ApiKeyAuth> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 19);

/**
 * @generated from message api.v1.user.EnsureUserProfileResponse
 */
export type EnsureUserProfileResponse = Message<"api.v1.user.EnsureUserProfileResponse"> & {
  /**
   * @generated from field: api.v1.user.UserProfile user_profile = 1;
   */
  userProfile?: UserProfile;

  /**
   * @generated from field: bool was_created = 2;
   */
  wasCreated: boolean;

  /**
   * @generated from field: optional string generated_username = 3;
   */
  generatedUsername?: string;
};

/**
 * Describes the message api.v1.user.EnsureUserProfileResponse.
 * Use `create(EnsureUserProfileResponseSchema)` to create a new message.
 */
export const EnsureUserProfileResponseSchema: GenMessage<EnsureUserProfileResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 20);

/**
 * @generated from message api.v1.user.GetOrganizationMembershipsRequest
 */
export type GetOrganizationMembershipsRequest = Message<"api.v1.user.GetOrganizationMembershipsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message api.v1.user.GetOrganizationMembershipsRequest.
 * Use `create(GetOrganizationMembershipsRequestSchema)` to create a new message.
 */
export const GetOrganizationMembershipsRequestSchema: GenMessage<GetOrganizationMembershipsRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 21);

/**
 * @generated from message api.v1.user.GetOrganizationMembershipsResponse
 */
export type GetOrganizationMembershipsResponse = Message<"api.v1.user.GetOrganizationMembershipsResponse"> & {
  /**
   * @generated from field: repeated api.v1.user.OrganizationMembership organization_memberships = 1;
   */
  organizationMemberships: OrganizationMembership[];
};

/**
 * Describes the message api.v1.user.GetOrganizationMembershipsResponse.
 * Use `create(GetOrganizationMembershipsResponseSchema)` to create a new message.
 */
export const GetOrganizationMembershipsResponseSchema: GenMessage<GetOrganizationMembershipsResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 22);

/**
 * @generated from message api.v1.user.OrganizationMembership
 */
export type OrganizationMembership = Message<"api.v1.user.OrganizationMembership"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * @generated from field: string organization_slug = 3;
   */
  organizationSlug: string;

  /**
   * @generated from field: string organization_image_url = 4;
   */
  organizationImageUrl: string;
};

/**
 * Describes the message api.v1.user.OrganizationMembership.
 * Use `create(OrganizationMembershipSchema)` to create a new message.
 */
export const OrganizationMembershipSchema: GenMessage<OrganizationMembership> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 23);

/**
 * @generated from message api.v1.user.SetActiveOrgRequest
 */
export type SetActiveOrgRequest = Message<"api.v1.user.SetActiveOrgRequest"> & {
  /**
   * @generated from field: optional string org_id = 1;
   */
  orgId?: string;
};

/**
 * Describes the message api.v1.user.SetActiveOrgRequest.
 * Use `create(SetActiveOrgRequestSchema)` to create a new message.
 */
export const SetActiveOrgRequestSchema: GenMessage<SetActiveOrgRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 24);

/**
 * @generated from message api.v1.user.SetActiveOrgResponse
 */
export type SetActiveOrgResponse = Message<"api.v1.user.SetActiveOrgResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api.v1.user.SetActiveOrgResponse.
 * Use `create(SetActiveOrgResponseSchema)` to create a new message.
 */
export const SetActiveOrgResponseSchema: GenMessage<SetActiveOrgResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 25);

/**
 * @generated from message api.v1.user.UpdateUsernameRequest
 */
export type UpdateUsernameRequest = Message<"api.v1.user.UpdateUsernameRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message api.v1.user.UpdateUsernameRequest.
 * Use `create(UpdateUsernameRequestSchema)` to create a new message.
 */
export const UpdateUsernameRequestSchema: GenMessage<UpdateUsernameRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 26);

/**
 * @generated from message api.v1.user.UpdateUsernameResponse
 */
export type UpdateUsernameResponse = Message<"api.v1.user.UpdateUsernameResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message api.v1.user.UpdateUsernameResponse.
 * Use `create(UpdateUsernameResponseSchema)` to create a new message.
 */
export const UpdateUsernameResponseSchema: GenMessage<UpdateUsernameResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 27);

/**
 * @generated from message api.v1.user.GetFirebaseUserByEmailRequest
 */
export type GetFirebaseUserByEmailRequest = Message<"api.v1.user.GetFirebaseUserByEmailRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message api.v1.user.GetFirebaseUserByEmailRequest.
 * Use `create(GetFirebaseUserByEmailRequestSchema)` to create a new message.
 */
export const GetFirebaseUserByEmailRequestSchema: GenMessage<GetFirebaseUserByEmailRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 28);

/**
 * @generated from message api.v1.user.GetFirebaseUserByEmailResponse
 */
export type GetFirebaseUserByEmailResponse = Message<"api.v1.user.GetFirebaseUserByEmailResponse"> & {
  /**
   * @generated from field: optional api.v1.user.FirebaseUser user = 1;
   */
  user?: FirebaseUser;
};

/**
 * Describes the message api.v1.user.GetFirebaseUserByEmailResponse.
 * Use `create(GetFirebaseUserByEmailResponseSchema)` to create a new message.
 */
export const GetFirebaseUserByEmailResponseSchema: GenMessage<GetFirebaseUserByEmailResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 29);

/**
 * @generated from message api.v1.user.UpdatePreferencesRequest
 */
export type UpdatePreferencesRequest = Message<"api.v1.user.UpdatePreferencesRequest"> & {
  /**
   * @generated from field: api.v1.user.NotificationSettings notification_settings = 1;
   */
  notificationSettings?: NotificationSettings;

  /**
   * @generated from field: api.v1.user.EmailPreferences email_preferences = 2;
   */
  emailPreferences?: EmailPreferences;

  /**
   * @generated from field: api.v1.user.PrivacySettings privacy_settings = 3;
   */
  privacySettings?: PrivacySettings;
};

/**
 * Describes the message api.v1.user.UpdatePreferencesRequest.
 * Use `create(UpdatePreferencesRequestSchema)` to create a new message.
 */
export const UpdatePreferencesRequestSchema: GenMessage<UpdatePreferencesRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 30);

/**
 * @generated from message api.v1.user.UpdatePreferencesResponse
 */
export type UpdatePreferencesResponse = Message<"api.v1.user.UpdatePreferencesResponse"> & {
  /**
   * @generated from field: api.v1.user.UserPreferences preferences = 1;
   */
  preferences?: UserPreferences;
};

/**
 * Describes the message api.v1.user.UpdatePreferencesResponse.
 * Use `create(UpdatePreferencesResponseSchema)` to create a new message.
 */
export const UpdatePreferencesResponseSchema: GenMessage<UpdatePreferencesResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 31);

/**
 * @generated from message api.v1.user.GetPreferencesResponse
 */
export type GetPreferencesResponse = Message<"api.v1.user.GetPreferencesResponse"> & {
  /**
   * @generated from field: api.v1.user.UserPreferences preferences = 1;
   */
  preferences?: UserPreferences;
};

/**
 * Describes the message api.v1.user.GetPreferencesResponse.
 * Use `create(GetPreferencesResponseSchema)` to create a new message.
 */
export const GetPreferencesResponseSchema: GenMessage<GetPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 32);

/**
 * @generated from message api.v1.user.UpdateLocationPreferencesRequest
 */
export type UpdateLocationPreferencesRequest = Message<"api.v1.user.UpdateLocationPreferencesRequest"> & {
  /**
   * @generated from field: api.v1.user.LocationSearchType search_location_type = 1;
   */
  searchLocationType: LocationSearchType;

  /**
   * @generated from field: optional string search_postal_code = 2;
   */
  searchPostalCode?: string;

  /**
   * @generated from field: optional int32 search_radius_km = 3;
   */
  searchRadiusKm?: number;

  /**
   * @generated from field: optional google.type.LatLng search_coordinates = 4;
   */
  searchCoordinates?: LatLng;
};

/**
 * Describes the message api.v1.user.UpdateLocationPreferencesRequest.
 * Use `create(UpdateLocationPreferencesRequestSchema)` to create a new message.
 */
export const UpdateLocationPreferencesRequestSchema: GenMessage<UpdateLocationPreferencesRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 33);

/**
 * @generated from message api.v1.user.UpdateLocationPreferencesResponse
 */
export type UpdateLocationPreferencesResponse = Message<"api.v1.user.UpdateLocationPreferencesResponse"> & {
  /**
   * @generated from field: api.v1.user.LocationPreferences location_preferences = 1;
   */
  locationPreferences?: LocationPreferences;
};

/**
 * Describes the message api.v1.user.UpdateLocationPreferencesResponse.
 * Use `create(UpdateLocationPreferencesResponseSchema)` to create a new message.
 */
export const UpdateLocationPreferencesResponseSchema: GenMessage<UpdateLocationPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 34);

/**
 * @generated from message api.v1.user.GetLocationPreferencesResponse
 */
export type GetLocationPreferencesResponse = Message<"api.v1.user.GetLocationPreferencesResponse"> & {
  /**
   * @generated from field: api.v1.user.LocationPreferences location_preferences = 1;
   */
  locationPreferences?: LocationPreferences;
};

/**
 * Describes the message api.v1.user.GetLocationPreferencesResponse.
 * Use `create(GetLocationPreferencesResponseSchema)` to create a new message.
 */
export const GetLocationPreferencesResponseSchema: GenMessage<GetLocationPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 35);

/**
 * SaveLocationRequest is the request to save a new location
 *
 * @generated from message api.v1.user.SaveLocationRequest
 */
export type SaveLocationRequest = Message<"api.v1.user.SaveLocationRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: api.v1.user.SavedLocation location = 2;
   */
  location?: SavedLocation;
};

/**
 * Describes the message api.v1.user.SaveLocationRequest.
 * Use `create(SaveLocationRequestSchema)` to create a new message.
 */
export const SaveLocationRequestSchema: GenMessage<SaveLocationRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 36);

/**
 * SaveLocationResponse is the response for saving a location
 *
 * @generated from message api.v1.user.SaveLocationResponse
 */
export type SaveLocationResponse = Message<"api.v1.user.SaveLocationResponse"> & {
  /**
   * @generated from field: api.v1.user.SavedLocation location = 1;
   */
  location?: SavedLocation;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message api.v1.user.SaveLocationResponse.
 * Use `create(SaveLocationResponseSchema)` to create a new message.
 */
export const SaveLocationResponseSchema: GenMessage<SaveLocationResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 37);

/**
 * RemoveSavedLocationRequest is the request to remove a saved location
 *
 * @generated from message api.v1.user.RemoveSavedLocationRequest
 */
export type RemoveSavedLocationRequest = Message<"api.v1.user.RemoveSavedLocationRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;
};

/**
 * Describes the message api.v1.user.RemoveSavedLocationRequest.
 * Use `create(RemoveSavedLocationRequestSchema)` to create a new message.
 */
export const RemoveSavedLocationRequestSchema: GenMessage<RemoveSavedLocationRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 38);

/**
 * GetSavedLocationsRequest is the request to get user's saved locations
 *
 * @generated from message api.v1.user.GetSavedLocationsRequest
 */
export type GetSavedLocationsRequest = Message<"api.v1.user.GetSavedLocationsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message api.v1.user.GetSavedLocationsRequest.
 * Use `create(GetSavedLocationsRequestSchema)` to create a new message.
 */
export const GetSavedLocationsRequestSchema: GenMessage<GetSavedLocationsRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 39);

/**
 * GetSavedLocationsResponse is the response containing saved locations
 *
 * @generated from message api.v1.user.GetSavedLocationsResponse
 */
export type GetSavedLocationsResponse = Message<"api.v1.user.GetSavedLocationsResponse"> & {
  /**
   * @generated from field: repeated api.v1.user.SavedLocation saved_locations = 1;
   */
  savedLocations: SavedLocation[];

  /**
   * ID of the primary location
   *
   * @generated from field: optional string primary_location_id = 2;
   */
  primaryLocationId?: string;
};

/**
 * Describes the message api.v1.user.GetSavedLocationsResponse.
 * Use `create(GetSavedLocationsResponseSchema)` to create a new message.
 */
export const GetSavedLocationsResponseSchema: GenMessage<GetSavedLocationsResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 40);

/**
 * UpdateSavedLocationRequest is the request to update a saved location
 *
 * @generated from message api.v1.user.UpdateSavedLocationRequest
 */
export type UpdateSavedLocationRequest = Message<"api.v1.user.UpdateSavedLocationRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;

  /**
   * @generated from field: api.v1.user.SavedLocation location = 3;
   */
  location?: SavedLocation;
};

/**
 * Describes the message api.v1.user.UpdateSavedLocationRequest.
 * Use `create(UpdateSavedLocationRequestSchema)` to create a new message.
 */
export const UpdateSavedLocationRequestSchema: GenMessage<UpdateSavedLocationRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 41);

/**
 * UpdateSavedLocationResponse is the response for updating a location
 *
 * @generated from message api.v1.user.UpdateSavedLocationResponse
 */
export type UpdateSavedLocationResponse = Message<"api.v1.user.UpdateSavedLocationResponse"> & {
  /**
   * @generated from field: api.v1.user.SavedLocation location = 1;
   */
  location?: SavedLocation;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message api.v1.user.UpdateSavedLocationResponse.
 * Use `create(UpdateSavedLocationResponseSchema)` to create a new message.
 */
export const UpdateSavedLocationResponseSchema: GenMessage<UpdateSavedLocationResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 42);

/**
 * SetPrimaryLocationRequest is the request to set a primary location
 *
 * @generated from message api.v1.user.SetPrimaryLocationRequest
 */
export type SetPrimaryLocationRequest = Message<"api.v1.user.SetPrimaryLocationRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;
};

/**
 * Describes the message api.v1.user.SetPrimaryLocationRequest.
 * Use `create(SetPrimaryLocationRequestSchema)` to create a new message.
 */
export const SetPrimaryLocationRequestSchema: GenMessage<SetPrimaryLocationRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 43);

/**
 * SetPrimaryLocationResponse is the response for setting primary location
 *
 * @generated from message api.v1.user.SetPrimaryLocationResponse
 */
export type SetPrimaryLocationResponse = Message<"api.v1.user.SetPrimaryLocationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string primary_location_id = 2;
   */
  primaryLocationId: string;
};

/**
 * Describes the message api.v1.user.SetPrimaryLocationResponse.
 * Use `create(SetPrimaryLocationResponseSchema)` to create a new message.
 */
export const SetPrimaryLocationResponseSchema: GenMessage<SetPrimaryLocationResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 44);

/**
 * LocationSearchHistoryRequest is the request to get location search history
 *
 * @generated from message api.v1.user.LocationSearchHistoryRequest
 */
export type LocationSearchHistoryRequest = Message<"api.v1.user.LocationSearchHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message api.v1.user.LocationSearchHistoryRequest.
 * Use `create(LocationSearchHistoryRequestSchema)` to create a new message.
 */
export const LocationSearchHistoryRequestSchema: GenMessage<LocationSearchHistoryRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 45);

/**
 * LocationSearchRecord represents a location search entry
 *
 * @generated from message api.v1.user.LocationSearchRecord
 */
export type LocationSearchRecord = Message<"api.v1.user.LocationSearchRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.type.LatLng search_location = 2;
   */
  searchLocation?: LatLng;

  /**
   * @generated from field: int32 radius_km = 3;
   */
  radiusKm: number;

  /**
   * @generated from field: repeated string searched_entity_types = 4;
   */
  searchedEntityTypes: string[];

  /**
   * @generated from field: int32 results_count = 5;
   */
  resultsCount: number;

  /**
   * @generated from field: optional string search_query = 6;
   */
  searchQuery?: string;

  /**
   * @generated from field: google.protobuf.Timestamp searched_at = 7;
   */
  searchedAt?: Timestamp;
};

/**
 * Describes the message api.v1.user.LocationSearchRecord.
 * Use `create(LocationSearchRecordSchema)` to create a new message.
 */
export const LocationSearchRecordSchema: GenMessage<LocationSearchRecord> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 46);

/**
 * LocationSearchHistoryResponse is the response containing search history
 *
 * @generated from message api.v1.user.LocationSearchHistoryResponse
 */
export type LocationSearchHistoryResponse = Message<"api.v1.user.LocationSearchHistoryResponse"> & {
  /**
   * @generated from field: repeated api.v1.user.LocationSearchRecord searches = 1;
   */
  searches: LocationSearchRecord[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message api.v1.user.LocationSearchHistoryResponse.
 * Use `create(LocationSearchHistoryResponseSchema)` to create a new message.
 */
export const LocationSearchHistoryResponseSchema: GenMessage<LocationSearchHistoryResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 47);

/**
 * @generated from message api.v1.user.ActiveOrg
 */
export type ActiveOrg = Message<"api.v1.user.ActiveOrg"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional string image_url = 4;
   */
  imageUrl?: string;
};

/**
 * Describes the message api.v1.user.ActiveOrg.
 * Use `create(ActiveOrgSchema)` to create a new message.
 */
export const ActiveOrgSchema: GenMessage<ActiveOrg> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 48);

/**
 * @generated from message api.v1.user.GetUserRequest
 */
export type GetUserRequest = Message<"api.v1.user.GetUserRequest"> & {
  /**
   * @generated from oneof api.v1.user.GetUserRequest.identifier
   */
  identifier: {
    /**
     * @generated from field: string user_id = 2;
     */
    value: string;
    case: "userId";
  } | {
    /**
     * @generated from field: string username = 3;
     */
    value: string;
    case: "username";
  } | {
    /**
     * @generated from field: string email = 4;
     */
    value: string;
    case: "email";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message api.v1.user.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 49);

/**
 * @generated from message api.v1.user.GetUserResponse
 */
export type GetUserResponse = Message<"api.v1.user.GetUserResponse"> & {
  /**
   * @generated from field: optional api.v1.user.UserProfile user_profile = 1;
   */
  userProfile?: UserProfile;
};

/**
 * Describes the message api.v1.user.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 50);

/**
 * @generated from message api.v1.user.FollowUserRequest
 */
export type FollowUserRequest = Message<"api.v1.user.FollowUserRequest"> & {
  /**
   * @generated from field: string follower_id = 1;
   */
  followerId: string;

  /**
   * @generated from field: string followee_id = 2;
   */
  followeeId: string;
};

/**
 * Describes the message api.v1.user.FollowUserRequest.
 * Use `create(FollowUserRequestSchema)` to create a new message.
 */
export const FollowUserRequestSchema: GenMessage<FollowUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 51);

/**
 * @generated from message api.v1.user.UnfollowUserRequest
 */
export type UnfollowUserRequest = Message<"api.v1.user.UnfollowUserRequest"> & {
  /**
   * @generated from field: string follower_id = 1;
   */
  followerId: string;

  /**
   * @generated from field: string followee_id = 2;
   */
  followeeId: string;
};

/**
 * Describes the message api.v1.user.UnfollowUserRequest.
 * Use `create(UnfollowUserRequestSchema)` to create a new message.
 */
export const UnfollowUserRequestSchema: GenMessage<UnfollowUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 52);

/**
 * @generated from message api.v1.user.GetUserFollowingInfoRequest
 */
export type GetUserFollowingInfoRequest = Message<"api.v1.user.GetUserFollowingInfoRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * ID of user viewing the profile (for mutual following)
   *
   * @generated from field: optional string viewer_id = 2;
   */
  viewerId?: string;
};

/**
 * Describes the message api.v1.user.GetUserFollowingInfoRequest.
 * Use `create(GetUserFollowingInfoRequestSchema)` to create a new message.
 */
export const GetUserFollowingInfoRequestSchema: GenMessage<GetUserFollowingInfoRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 53);

/**
 * @generated from message api.v1.user.GetUserFollowingInfoResponse
 */
export type GetUserFollowingInfoResponse = Message<"api.v1.user.GetUserFollowingInfoResponse"> & {
  /**
   * @generated from field: int32 followers_count = 1;
   */
  followersCount: number;

  /**
   * @generated from field: int32 following_count = 2;
   */
  followingCount: number;

  /**
   * true if viewer_id follows user_id
   *
   * @generated from field: bool is_following = 3;
   */
  isFollowing: boolean;

  /**
   * true if user_id follows viewer_id
   *
   * @generated from field: bool is_followed_by = 4;
   */
  isFollowedBy: boolean;

  /**
   * IDs of mutual followers
   *
   * @generated from field: repeated string mutual_followers = 5;
   */
  mutualFollowers: string[];
};

/**
 * Describes the message api.v1.user.GetUserFollowingInfoResponse.
 * Use `create(GetUserFollowingInfoResponseSchema)` to create a new message.
 */
export const GetUserFollowingInfoResponseSchema: GenMessage<GetUserFollowingInfoResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 54);

/**
 * @generated from message api.v1.user.ListUserFollowersRequest
 */
export type ListUserFollowersRequest = Message<"api.v1.user.ListUserFollowersRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message api.v1.user.ListUserFollowersRequest.
 * Use `create(ListUserFollowersRequestSchema)` to create a new message.
 */
export const ListUserFollowersRequestSchema: GenMessage<ListUserFollowersRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 55);

/**
 * @generated from message api.v1.user.ListUserFollowersResponse
 */
export type ListUserFollowersResponse = Message<"api.v1.user.ListUserFollowersResponse"> & {
  /**
   * @generated from field: repeated api.v1.user.UserFollowerProfile followers = 1;
   */
  followers: UserFollowerProfile[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message api.v1.user.ListUserFollowersResponse.
 * Use `create(ListUserFollowersResponseSchema)` to create a new message.
 */
export const ListUserFollowersResponseSchema: GenMessage<ListUserFollowersResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 56);

/**
 * @generated from message api.v1.user.ListUserFollowingRequest
 */
export type ListUserFollowingRequest = Message<"api.v1.user.ListUserFollowingRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message api.v1.user.ListUserFollowingRequest.
 * Use `create(ListUserFollowingRequestSchema)` to create a new message.
 */
export const ListUserFollowingRequestSchema: GenMessage<ListUserFollowingRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 57);

/**
 * @generated from message api.v1.user.ListUserFollowingResponse
 */
export type ListUserFollowingResponse = Message<"api.v1.user.ListUserFollowingResponse"> & {
  /**
   * @generated from field: repeated api.v1.user.UserFollowingProfile following = 1;
   */
  following: UserFollowingProfile[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message api.v1.user.ListUserFollowingResponse.
 * Use `create(ListUserFollowingResponseSchema)` to create a new message.
 */
export const ListUserFollowingResponseSchema: GenMessage<ListUserFollowingResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 58);

/**
 * @generated from message api.v1.user.UserFollowerProfile
 */
export type UserFollowerProfile = Message<"api.v1.user.UserFollowerProfile"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: optional string bio = 3;
   */
  bio?: string;

  /**
   * @generated from field: google.protobuf.Timestamp followed_at = 4;
   */
  followedAt?: Timestamp;

  /**
   * @generated from field: api.v1.user.EntityType entity_type = 5;
   */
  entityType: EntityType;

  /**
   * @generated from field: optional string avatar_url = 6;
   */
  avatarUrl?: string;
};

/**
 * Describes the message api.v1.user.UserFollowerProfile.
 * Use `create(UserFollowerProfileSchema)` to create a new message.
 */
export const UserFollowerProfileSchema: GenMessage<UserFollowerProfile> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 59);

/**
 * @generated from message api.v1.user.UserFollowingProfile
 */
export type UserFollowingProfile = Message<"api.v1.user.UserFollowingProfile"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: optional string bio = 3;
   */
  bio?: string;

  /**
   * @generated from field: google.protobuf.Timestamp followed_at = 4;
   */
  followedAt?: Timestamp;

  /**
   * @generated from field: api.v1.user.EntityType entity_type = 5;
   */
  entityType: EntityType;

  /**
   * @generated from field: optional string avatar_url = 6;
   */
  avatarUrl?: string;
};

/**
 * Describes the message api.v1.user.UserFollowingProfile.
 * Use `create(UserFollowingProfileSchema)` to create a new message.
 */
export const UserFollowingProfileSchema: GenMessage<UserFollowingProfile> = /*@__PURE__*/
  messageDesc(file_v1_user_user_service, 60);

/**
 * @generated from enum api.v1.user.LocationSearchType
 */
export enum LocationSearchType {
  /**
   * @generated from enum value: LOCATION_SEARCH_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOCATION_SEARCH_TYPE_COMMUNITY = 1;
   */
  COMMUNITY = 1,

  /**
   * @generated from enum value: LOCATION_SEARCH_TYPE_BEYOND = 2;
   */
  BEYOND = 2,
}

/**
 * Describes the enum api.v1.user.LocationSearchType.
 */
export const LocationSearchTypeSchema: GenEnum<LocationSearchType> = /*@__PURE__*/
  enumDesc(file_v1_user_user_service, 0);

/**
 * Enhanced location enums and types
 *
 * @generated from enum api.v1.user.LocationUnit
 */
export enum LocationUnit {
  /**
   * @generated from enum value: LOCATION_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOCATION_UNIT_KILOMETERS = 1;
   */
  KILOMETERS = 1,

  /**
   * @generated from enum value: LOCATION_UNIT_MILES = 2;
   */
  MILES = 2,
}

/**
 * Describes the enum api.v1.user.LocationUnit.
 */
export const LocationUnitSchema: GenEnum<LocationUnit> = /*@__PURE__*/
  enumDesc(file_v1_user_user_service, 1);

/**
 * @generated from enum api.v1.user.LocationSharingLevel
 */
export enum LocationSharingLevel {
  /**
   * @generated from enum value: LOCATION_SHARING_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Share exact coordinates
   *
   * @generated from enum value: LOCATION_SHARING_LEVEL_EXACT = 1;
   */
  EXACT = 1,

  /**
   * Share city-level location
   *
   * @generated from enum value: LOCATION_SHARING_LEVEL_CITY = 2;
   */
  CITY = 2,

  /**
   * Share state-level location
   *
   * @generated from enum value: LOCATION_SHARING_LEVEL_STATE = 3;
   */
  STATE = 3,

  /**
   * Don't share location
   *
   * @generated from enum value: LOCATION_SHARING_LEVEL_NONE = 4;
   */
  NONE = 4,
}

/**
 * Describes the enum api.v1.user.LocationSharingLevel.
 */
export const LocationSharingLevelSchema: GenEnum<LocationSharingLevel> = /*@__PURE__*/
  enumDesc(file_v1_user_user_service, 2);

/**
 * Entity types for following relationships
 *
 * @generated from enum api.v1.user.EntityType
 */
export enum EntityType {
  /**
   * @generated from enum value: ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENTITY_TYPE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: ENTITY_TYPE_ORGANIZATION = 2;
   */
  ORGANIZATION = 2,
}

/**
 * Describes the enum api.v1.user.EntityType.
 */
export const EntityTypeSchema: GenEnum<EntityType> = /*@__PURE__*/
  enumDesc(file_v1_user_user_service, 3);

/**
 * UserService handles user management and onboarding
 *
 * @generated from service api.v1.user.UserService
 */
export const UserService: GenService<{
  /**
   * Get a user by their ID or return null if not found
   *
   * @generated from rpc api.v1.user.UserService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.GetFirebaseUserByEmail
   */
  getFirebaseUserByEmail: {
    methodKind: "unary";
    input: typeof GetFirebaseUserByEmailRequestSchema;
    output: typeof GetFirebaseUserByEmailResponseSchema;
  },
  /**
   * User Account Management
   *
   * @generated from rpc api.v1.user.UserService.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateUserRequestSchema;
    output: typeof CreateUserResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteUserRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * User Lookup & Validation
   *
   * @generated from rpc api.v1.user.UserService.CheckUsername
   */
  checkUsername: {
    methodKind: "unary";
    input: typeof CheckUsernameRequestSchema;
    output: typeof CheckUsernameResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.UpdateUsername
   */
  updateUsername: {
    methodKind: "unary";
    input: typeof UpdateUsernameRequestSchema;
    output: typeof UpdateUsernameResponseSchema;
  },
  /**
   * Ensure User Profile - JIT sync Firebase auth to PostgreSQL
   *
   * @generated from rpc api.v1.user.UserService.EnsureUserProfile
   */
  ensureUserProfile: {
    methodKind: "unary";
    input: typeof EnsureUserProfileRequestSchema;
    output: typeof EnsureUserProfileResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.GetOrganizationMemberships
   */
  getOrganizationMemberships: {
    methodKind: "unary";
    input: typeof GetOrganizationMembershipsRequestSchema;
    output: typeof GetOrganizationMembershipsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.SetActiveOrg
   */
  setActiveOrg: {
    methodKind: "unary";
    input: typeof SetActiveOrgRequestSchema;
    output: typeof SetActiveOrgResponseSchema;
  },
  /**
   * Preferences Management
   *
   * @generated from rpc api.v1.user.UserService.UpdatePreferences
   */
  updatePreferences: {
    methodKind: "unary";
    input: typeof UpdatePreferencesRequestSchema;
    output: typeof UpdatePreferencesResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.GetPreferences
   */
  getPreferences: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetPreferencesResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.UpdateLocationPreferences
   */
  updateLocationPreferences: {
    methodKind: "unary";
    input: typeof UpdateLocationPreferencesRequestSchema;
    output: typeof UpdateLocationPreferencesResponseSchema;
  },
  /**
   * @generated from rpc api.v1.user.UserService.GetLocationPreferences
   */
  getLocationPreferences: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetLocationPreferencesResponseSchema;
  },
  /**
   * Save a new location for future use
   *
   * @generated from rpc api.v1.user.UserService.SaveLocation
   */
  saveLocation: {
    methodKind: "unary";
    input: typeof SaveLocationRequestSchema;
    output: typeof SaveLocationResponseSchema;
  },
  /**
   * Remove a saved location
   *
   * @generated from rpc api.v1.user.UserService.RemoveSavedLocation
   */
  removeSavedLocation: {
    methodKind: "unary";
    input: typeof RemoveSavedLocationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Get all saved locations for a user
   *
   * @generated from rpc api.v1.user.UserService.GetSavedLocations
   */
  getSavedLocations: {
    methodKind: "unary";
    input: typeof GetSavedLocationsRequestSchema;
    output: typeof GetSavedLocationsResponseSchema;
  },
  /**
   * Update an existing saved location
   *
   * @generated from rpc api.v1.user.UserService.UpdateSavedLocation
   */
  updateSavedLocation: {
    methodKind: "unary";
    input: typeof UpdateSavedLocationRequestSchema;
    output: typeof UpdateSavedLocationResponseSchema;
  },
  /**
   * Set a saved location as the primary location
   *
   * @generated from rpc api.v1.user.UserService.SetPrimaryLocation
   */
  setPrimaryLocation: {
    methodKind: "unary";
    input: typeof SetPrimaryLocationRequestSchema;
    output: typeof SetPrimaryLocationResponseSchema;
  },
  /**
   * Get user's location search history
   *
   * @generated from rpc api.v1.user.UserService.GetLocationSearchHistory
   */
  getLocationSearchHistory: {
    methodKind: "unary";
    input: typeof LocationSearchHistoryRequestSchema;
    output: typeof LocationSearchHistoryResponseSchema;
  },
  /**
   * CreateImage creates an image
   *
   * @generated from rpc api.v1.user.UserService.CreateImage
   */
  createImage: {
    methodKind: "unary";
    input: typeof CreateImageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Follow another user
   *
   * @generated from rpc api.v1.user.UserService.FollowUser
   */
  followUser: {
    methodKind: "unary";
    input: typeof FollowUserRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Unfollow a user
   *
   * @generated from rpc api.v1.user.UserService.UnfollowUser
   */
  unfollowUser: {
    methodKind: "unary";
    input: typeof UnfollowUserRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Get user following info (followers count, following count, mutual status)
   *
   * @generated from rpc api.v1.user.UserService.GetUserFollowingInfo
   */
  getUserFollowingInfo: {
    methodKind: "unary";
    input: typeof GetUserFollowingInfoRequestSchema;
    output: typeof GetUserFollowingInfoResponseSchema;
  },
  /**
   * List followers of a user
   *
   * @generated from rpc api.v1.user.UserService.ListUserFollowers
   */
  listUserFollowers: {
    methodKind: "unary";
    input: typeof ListUserFollowersRequestSchema;
    output: typeof ListUserFollowersResponseSchema;
  },
  /**
   * List users that a user follows
   *
   * @generated from rpc api.v1.user.UserService.ListUserFollowing
   */
  listUserFollowing: {
    methodKind: "unary";
    input: typeof ListUserFollowingRequestSchema;
    output: typeof ListUserFollowingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_user_user_service, 0);

